import { type FC, useState } from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';

import './styles/styles.css';
import Stepper from '../../Stepper/Stepper';
import { DatesStep } from './DatesStep';
import { GuestInformationStep } from './GuestInformationStep';
import { ReservationTypeStep } from './ReservationTypeStep';
import { RoomReassignmentStep } from './RoomReassignmentStep';

export interface NewRoleModalData {
  show: boolean;
  handleClose: () => void;
}

const steps = [
  <ReservationTypeStep />,
  <DatesStep />,
  <GuestInformationStep />,
  <RoomReassignmentStep />,
];

export const ReservationGroupModal: FC<NewRoleModalData> = ({ show, handleClose }) => {
  const methods = useForm();
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = async () => {
    const isValid = await methods.trigger();
    if (!isValid) return;

    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };
  const setStep = (step: number) => {
    setCurrentStep(step);
  };

  const onSubmit = methods.handleSubmit((data) => {
    // TODO: send the form data
  });

  return (
    <div>
      <Modal
        className="user--role-modal new-role-modal edit--user-modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0">
          <span className="modal-title"> New Reservation</span>
        </Modal.Header>
        <div className="stepper-row">
          <Stepper currentStep={currentStep} setStep={setStep} />
        </div>
        <FormProvider {...methods}>
          <form onSubmit={onSubmit}>
            <Modal.Body>
              <Container>
                <div className="mt-16px">{steps[currentStep]}</div>
              </Container>
            </Modal.Body>
            <Modal.Footer className="border-0 justify-content-between">
              <Button className="cancel-button" onClick={handleClose}>
                Cancel
              </Button>
              <div className="mt-4 d-flex ">
                <Button
                  className="cancel-button"
                  onClick={handleBack}
                  disabled={currentStep === 0}
                  style={{ marginRight: '10px' }}
                >
                  Back
                </Button>

                {currentStep === steps.length - 1 ? (
                  <Button className="save-button" type="submit">
                    Submit
                  </Button>
                ) : (
                  <Button className="save-button" onClick={handleNext}>
                    Next
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </form>
        </FormProvider>
      </Modal>
    </div>
  );
};
